import React from 'react';

import Form from "../Form";



export default ({user, onSuccess = response => response, onSubmitting = () => null, onError = err => err}) => 
  <Form user={user} onSubmitting={onSubmitting} onError={onError} onSuccess={onSuccess} />
